import React, { useState, useEffect } from "react";
import '../css/dashboard_style.css';
import { API_URL_BASE } from '../config.js';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Tooltip,
  Legend
} from "recharts";




export default function TicketChart({ events = []}) {
	 const [loading, setLoading] = useState(true);
	 const [token, setToken] = useState('');
	 const [bardata, setBarData] = useState([]);
	 const [piedata, setPieData] = useState([]);
	 

	 const COLORS = ["#F44336", "#0088FE", "#FF8042"]; // Red , Blue for sold, orange for available
	 
	 // Step 1: Set token from localStorage
	 	useEffect(() => {
	 	  const storedToken = localStorage.getItem('token');
	 	  if (storedToken) {
	 	    setToken(storedToken);
	 	  } else {
	 	    // Optional: redirect to login or show fallback
	 	    console.warn("No token found in localStorage");
	 	    setLoading(false);
			//navigate("/");
	 	  }
	 	}, []);
	 	
	 
		// Step 2 : fetch details
	 useEffect(() => {
		if (!token) return; // Don't run if token is not ready
		
	   if (events && events.length > 0) {
		fetch(API_URL_BASE + `/ticket.json`,{
		method: 'POST',
			     headers: {
			       'Content-Type': 'application/json',
			     },
			     body: JSON.stringify({
			       fetchchartdata: {
			           token: token
			       }
			     }),
			   })
		    .then(res => {
		      if (!res.ok) throw new Error('Event not found');
		      return res.json();
		    })
		    .then(data => {
				
				console.log(data);
				
				if (data.eventchartdetail.eventchart && data.eventchartdetail.eventchart.length > 0) {
							 const newBarData = data.eventchartdetail.eventchart.map((event) => ({
								name: event.eventname,       // use eventname from backend
								Available: (event.capacity - event.ticketsold),    // first metric
								Sold: event.ticketsold // second metric
							 }));
							 setBarData(newBarData);
							 
							 if (data.eventchartdetail?.eventchart?.length > 0) {
							   // Sum capacity and sold across all events
							   let totalCapacity = 0;
							   let totalSold = 0;

							   data.eventchartdetail.eventchart.forEach((event) => {
							     totalCapacity += event.capacity;
							     totalSold += event.ticketsold;
							   });

							   const totalAvailable = totalCapacity - totalSold;

							   // Build pie data
							   const pieData = [
							     { name: "Sold", value: totalSold },
							     { name: "Available", value: totalAvailable }
							   ];

							   setPieData(pieData);
							} 
							
							
			
		    }})
		    .catch(err => {
		      console.error('Error loading event:', err);
		     // setEventResult(null);
		    })
		    .finally(() => setLoading(false));
	     //setBarData(newBarData);
	   }
	 }, [events]);
	 
	 
	 
  return (
      <div className="chart-wrapper">
	  {/* Bar Chart */}
	  <div className="chart-box">
	  <div className="chart-title">Tickets Overview (Capacity vs Sold)</div>
	    <ResponsiveContainer width="100%" height={window.innerWidth < 768 ? 200 : 300} >
	      <BarChart data={bardata} barSize={36}>
	        <CartesianGrid strokeDasharray="3 3" />
	        <XAxis dataKey="name" />
	        <YAxis allowDecimals={false} />
	        <Tooltip />
	        <Legend />
	  	  <Bar dataKey="Available" stackId="tickets" fill={COLORS[1]} />
	  	  <Bar dataKey="Sold" stackId="tickets" fill={COLORS[0]} />
	      </BarChart>
	    </ResponsiveContainer>
	  </div>
	  
        {/* Pie Chart */}
        <div className="chart-box">
		<div className="chart-title">Ticket Sales Distribution</div>
          <ResponsiveContainer width="100%" height={window.innerWidth < 768 ? 200 : 300} >
            <PieChart>
              <Pie
                data={piedata}
                dataKey="value"
                outerRadius={100}
                label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
              >
                {piedata.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        </div> 


      </div>

    );
};


